module.exports = __webpack_public_path__ + "img/start_screen.7610b025.jpg";